// import React from 'react'
import styled from 'styled-components'
import Banner from '../../components/Banner'
import Title from '../../components/Title'
import Button from '../../components/Button'
import Hr from '../../components/Hr'
import Paragraph from '../../components/Paragraph'
import img1 from '../../assets/static/capacity_img1.png'
import { Link } from 'react-router-dom'
import img2 from '../../assets/static/capacity_img2.jpg'
// import img3 from '../../assets/static/capacity_img3.jpg'
import img4 from '../../assets/static/capacity_img4.png'
import { useTranslation } from "react-i18next"
  
const About = () => {
  const { t } = useTranslation()
  return (
    <Main>
      <Banner title={t('capacity.hero.title')}>
        <>
          <Hr color="primary" />
          <Title size="small" color="white">
            {t('capacity.hero.desc')}
          </Title>
        </>
      </Banner>
      <Container>
        <Article1>
          <Grid2>
            <Left>
              <Title size="mid" color="black">
               {t('capacity.machines.0.title')}
              </Title>
              <Title size="small" color="black">
                {t('capacity.machines.0.subtitle')}
              </Title>
              <Hr align={'left'} />
              <Paragraph>
                {t('capacity.machines.0.desc')}
              </Paragraph>
              <Paragraph>
                {t('capacity.machines.0.descTwo')}
              </Paragraph>
            </Left>
            <div>
              <Img src={img1} alt="" />
            </div>
          </Grid2>
        </Article1>
        <Article4>
          <Grid2>
            <div>
              <Img src={img2} alt="" />
            </div>
            <Left>
              <Title size="mid" color="black">
              {t('capacity.machines.1.title')}
              </Title>
              <Title size="small" color="black">
              {t('capacity.machines.1.subtitle')}
              </Title>
              <Hr align={'left'} />
              <Paragraph>
                {t('capacity.machines.1.desc')}
              </Paragraph>
              <Paragraph>
              {t('capacity.machines.1.descTwo')}
              </Paragraph>
            </Left>
          </Grid2>
        </Article4>
      {/*   <Article1>
          <Grid2>
            <Left>
              <Title size="mid" color="black">
              {t('capacity.machines.2.title')}
              </Title>
              <Title size="small" color="black">
                {t('capacity.machines.2.subtitle')}
              </Title>
              <Hr align={'left'} />
              <Paragraph>
                {t('capacity.machines.2.desc')}
              </Paragraph>
            </Left>
            <div>
              <Img src={img3} alt="" />
            </div>
          </Grid2>
        </Article1> */}
        <Article3>
          <Left>
            <Float src={img4} alt="" />
            <Box>
              <Title size="small" color="white">
                {t('capacity.banner.title')}
              </Title>
              <Link to="/solutions">
                <Button>{t('capacity.banner.cta')}</Button>
              </Link>
            </Box>
          </Left>
          <Left>
            <Box>
              <Title size="mid" color="secondary">
                {t('capacity.bannerTwo.title')}
              </Title>
              <Title size="small" color="black">
                {t('capacity.bannerTwo.desc')}
              </Title>
              <Link to="/contact">
                <Button>{t('capacity.bannerTwo.cta')}</Button>
              </Link>
            </Box>
          </Left>
        </Article3>
      </Container>
    </Main>
  )
}

export default About

const Main = styled.main``
const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr minmax(375px, 1200px) 1fr;
  background-color: ${({ theme }) => theme.white};

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

const Article1 = styled.article`
  grid-column: 2/3;
  margin: 40px 0;

  @media (max-width: 768px) {
    grid-column: 1/2;
    padding: 0 20px;
  }
`

const Grid2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

const Left = styled.div`
  display: flex;
  flex-direction: column;
`

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

const Article3 = styled.article`
  grid-column: 1/4;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
  }
  & > div {
    width: 100%;
    position: relative;
    @media (max-width: 768px) {
      align-items: center;
      box-sizing: border-box;
      padding: 20px;
    }
  }
  & > div:nth-child(1) {
    background-color: ${({ theme }) => theme.bgWeb};
    display: flex;
    align-items: flex-end;
    padding: 50px 0;
    @media (max-width: 768px) {
      align-items: center;
      box-sizing: border-box;
      padding: 20px;
    }
  }
`

const Box = styled.div`
  width: 450px;
  margin: 0 25px;
  text-align: center;
  @media (max-width: 768px) {
    width: 100%;
  }
`

const Article4 = styled.article`
  grid-column: 1/4;
  margin-bottom: 30px;
  background-color: ${({ theme }) => theme.grayLight};
  display: grid;
  grid-template-columns: 1fr minmax(375px, 1200px) 1fr;
  padding: 50px 0;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    box-sizing: border-box;
    padding: 0 20px;
  }
  & > div {
    grid-column: 2/3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 50px;
    @media (max-width: 768px) {
      grid-column: 1/4;
      grid-template-columns: 1fr;
      box-sizing: border-box;

    }
  }
`

const Float = styled.img`
  position: absolute;
  top: -71px;
  left: 0;
  height: 300px;
  @media (max-width: 768px) {
    display: none;
  }
`
